module.exports = __webpack_public_path__ + "static/media/48059_587028817988012_41104531_n.de17b660.jpg";